import { reassessmentTriggerReasons } from 'constants/reassessmentTriggerReasons'
import { seasonalDistribution } from 'constants/seasonalDistribution'

export const SEASONS_PER_CONGREGATION_GROUP = 4

export const getCongregationNameByGroup = (groupId, options = []) => {
  const match = options.find((option) => option.value === groupId)
  return match ? match.label : 'newCongregationTitle'
}

export const getCongregationSeasonLabel = (item) => {
  if (!item?.season_id) {
    return null
  }

  if (item.SeasonalDistribution?.name) {
    return item.SeasonalDistribution.name
  }

  if (item.season_name) {
    return item.season_name
  }

  const seasonFromConstants = seasonalDistribution.find((season) => {
    return Number(season.id) === Number(item.season_id)
  })

  if (seasonFromConstants?.name) {
    return seasonFromConstants.name
  }

  return `Season ${item.season_id}`
}

export const getCongregationDisplayLabel = (item, groupOptions = []) => {
  const groupName = getCongregationNameByGroup(item?.CongregationGroupId, groupOptions)
  const seasonLabel = getCongregationSeasonLabel(item)

  if (!seasonLabel) {
    return groupName
  }

  return `${groupName} — ${seasonLabel}`
}

export const getUsedSeasonIdsForGroup = (congregationList = [], congregationGroupId, currentCongregationId) => {
  if (congregationGroupId == null || congregationGroupId === '') {
    return []
  }

  const normalizedGroupId = Number(congregationGroupId)

  if (!Number.isFinite(normalizedGroupId)) {
    return []
  }

  const normalizedCurrentId = currentCongregationId == null ? null : String(currentCongregationId)

  return congregationList
    .filter((congregation) => {
      return Number(congregation.CongregationGroupId) === normalizedGroupId
        && String(congregation.id) !== normalizedCurrentId
        && congregation.season_id != null
    })
    .map((congregation) => Number(congregation.season_id))
    .filter((seasonId) => Number.isFinite(seasonId))
}

export const canAddMoreCongregations = (congregationList = [], maxCongregations) => {
  const persistedCount = congregationList.filter((congregation) => {
    return congregation.id !== 'defaultTestId'
  }).length

  return persistedCount < maxCongregations
}

export const DEFAULT_CONGREGATION_PLACEHOLDER_ID = 'defaultTestId'

export const sortCongregationsByCreatedAtAsc = (congregationList = []) => {
  return [...congregationList].sort((a, b) => {
    if (a?.id === DEFAULT_CONGREGATION_PLACEHOLDER_ID) {
      return 1
    }
    if (b?.id === DEFAULT_CONGREGATION_PLACEHOLDER_ID) {
      return -1
    }

    const aTime = a?.createdAt ? new Date(a.createdAt).getTime() : 0
    const bTime = b?.createdAt ? new Date(b.createdAt).getTime() : 0

    if (aTime !== bTime) {
      return aTime - bTime
    }

    return String(a?.id ?? '').localeCompare(String(b?.id ?? ''))
  })
}

export const getRejectReasonNames = (triggerReasonIds = []) => {
  return triggerReasonIds
    .map((element) => reassessmentTriggerReasons.find((item) => item.id === Number(element))?.name)
    .filter(Boolean)
}

export const hasQualifyingReason = (reasons = []) => {
  if (!Array.isArray(reasons) || reasons.length === 0) return true
  return reasons.some((element) => Number(element) === 1)
}
